import { Assets, Texture } from 'pixi.js';

export class AssetLoader {
  private static instance: AssetLoader;
  private loaded = false;

  private constructor() {}

  static getInstance(): AssetLoader {
    if (!AssetLoader.instance) {
      AssetLoader.instance = new AssetLoader();
    }
    return AssetLoader.instance;
  }

  async loadAssets(): Promise<void> {
    if (this.loaded) {
      return;
    }

    Assets.add({ alias: 'background', src: '/assets/main/background.jpeg' });
    Assets.add({ alias: 'logo', src: '/assets/main/logo.png' });
    Assets.add({ alias: 'gameover', src: '/assets/main/gameover.png' });

    Assets.add({ alias: 'alici_run_1', src: '/assets/alici/run_1.png' });
    Assets.add({ alias: 'alici_run_2', src: '/assets/alici/run_2.png' });
    Assets.add({ alias: 'alici_run_3', src: '/assets/alici/run_3.png' });
    Assets.add({ alias: 'alici_jump', src: '/assets/alici/jump.png' });
    Assets.add({ alias: 'alici_slip', src: '/assets/alici/slip.png' });
    Assets.add({ alias: 'alici_poop', src: '/assets/alici/poop.png' });
    Assets.add({
      alias: 'alici_game_over',
      src: '/assets/alici/game_over.png',
    });

    Assets.add({ alias: 'jasper_poop', src: '/assets/jasper/poop.png' });
    Assets.add({ alias: 'jasper_run_1', src: '/assets/jasper/run_1.png' });
    Assets.add({ alias: 'jasper_run_2', src: '/assets/jasper/run_2.png' });
    Assets.add({ alias: 'jasper_run_3', src: '/assets/jasper/run_3.png' });
    Assets.add({ alias: 'jasper_jump', src: '/assets/jasper/jump.png' });
    Assets.add({ alias: 'jasper_slip', src: '/assets/jasper/slip.png' });
    Assets.add({
      alias: 'jasper_game_over',
      src: '/assets/jasper/game_over.png',
    });

    Assets.add({ alias: 'obstacle_boxes', src: '/assets/obstacles/boxes.png' });
    Assets.add({
      alias: 'obstacle_cucumber',
      src: '/assets/obstacles/cucumber.png',
    });
    Assets.add({
      alias: 'obstacle_flowerpot',
      src: '/assets/obstacles/flowerpot.png',
    });
    Assets.add({
      alias: 'obstacle_laundry',
      src: '/assets/obstacles/laundry.png',
    });
    Assets.add({
      alias: 'obstacle_roomba',
      src: '/assets/obstacles/roomba.png',
    });
    Assets.add({
      alias: 'obstacle_waterpool',
      src: '/assets/obstacles/waterpool.png',
    });
    Assets.add({
      alias: 'obstacle_washingmachine',
      src: '/assets/obstacles/washingmachine.png',
    });
    Assets.add({
      alias: 'obstacle_poop',
      src: '/assets/special/poop.png',
    });

    Assets.add({
      alias: 'platform_short',
      src: '/assets/platform/platform_short.png',
    });
    Assets.add({
      alias: 'platform_medium',
      src: '/assets/platform/platform_medium.png',
    });
    Assets.add({
      alias: 'platform_long',
      src: '/assets/platform/platform_long.png',
    });
    Assets.add({
      alias: 'chicken_treat',
      src: '/assets/special/chicken.png',
    });

    await Assets.load([
      'background',
      'logo',
      'gameover',
      'alici_run_1',
      'alici_run_2',
      'alici_run_3',
      'alici_jump',
      'alici_slip',
      'alici_poop',
      'alici_game_over',
      'jasper_poop',
      'jasper_run_1',
      'jasper_run_2',
      'jasper_run_3',
      'jasper_jump',
      'jasper_slip',
      'jasper_game_over',
      'obstacle_boxes',
      'obstacle_cucumber',
      'obstacle_flowerpot',
      'obstacle_laundry',
      'obstacle_roomba',
      'obstacle_waterpool',
      'obstacle_washingmachine',
      'obstacle_poop',
      'platform_short',
      'platform_medium',
      'platform_long',
      'chicken_treat',
    ]);

    this.loaded = true;
    console.log('Assets loaded');
  }

  getTexture(alias: string): Texture {
    return Assets.get(alias);
  }
}
